import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import sanitizeHtml from 'sanitize-html'

const SanitizedHtml = ({html, as: Component = Box, ...props}) => {
    const sanitizedHtml = sanitizeHtml(html || '')
    return <Component {...props} dangerouslySetInnerHTML={{__html: sanitizedHtml}} />
}

SanitizedHtml.propTypes = {
    html: PropTypes.string,
    as: PropTypes.elementType,
}

export default SanitizedHtml
